import React from 'react';
import { Coverage as CoverageScreen } from '../../components/coverage-screen';

export const Coverage = () => {

  return <CoverageScreen />;
};

export default Coverage;
